export default "__VITE_ASSET__DXpjgk2e__"